import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';

import { EcmDispatcherModule } from '@ecm/dispatcher';
import { Line, PortfolioService, UrlHelper } from '@ecm/portfolio';

import { RouterService } from '../services/router.service';

@Injectable({
    providedIn: 'root',
})
export class LineNumberToCidResolver {
    public constructor(
        protected portfolioService: PortfolioService,
        protected routerService: RouterService,
    ) {}

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const url: string = state.url;
        const cidMatch: string[] = UrlHelper.matchCid(url) || UrlHelper.matchSecurityCid(url);
        const lineNumber = route.queryParams.lineNumber;
        const cid: string = cidMatch ? cidMatch[1] : null;

        // cid can match lineNumber. If equal, then no lineNumber was provided
        if (lineNumber && (!cid || cid === lineNumber)) {
            return this.portfolioService.getRawContracts().pipe(
                map(({ contracts }) => {
                    const matchingContract = contracts.find((contract) => {
                        return contract.telco?.lineList?.some((line: Line) => line.lineNumber === lineNumber);
                    });
                    if (matchingContract) {
                        const cidPattern = route.params.cid;
                        EcmDispatcherModule.sendConsoleInfo(
                            LineNumberToCidResolver.name,
                            `${lineNumber} matches portfolio, will replace ${cidPattern} by ${matchingContract.cid} and retry`,
                        );
                        this.routerService.navigateByUrl(decodeURI(url).replace(cidPattern, matchingContract.cid));
                        return false;
                    } else {
                        EcmDispatcherModule.sendConsoleInfo(
                            LineNumberToCidResolver.name,
                            `${lineNumber} does not match portfolio, will let go to route ${url} without changes`,
                        );
                        return true;
                    }
                }),
            );
        } else {
            EcmDispatcherModule.sendConsoleInfo(
                LineNumberToCidResolver.name,
                `No lineNumber found OR cid already provided`,
            );
            return of(true);
        }
    }
}
